import React from 'react';
import { Edit } from '@mui/icons-material';
import {
  Box,
  Typography,
  Divider,
  Tooltip,
  TextField,
  Stack,
  IconButton,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { setCurrentRecording } from '../redux/actions/currentRecording';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { openSnackbar } from '../redux/actions/snackbarAction';
import { isMobile, isTablet } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes';

const MeetingTitle = ({
  meetingTitle,
  isEditingTitle,
  setMeetingTitle,
  handleTitleSave: onTitleSave,
  handleTitleEdit: onTitleEdit,
  handleTitleBlur: onTitleBlur,
  details,
  navigate: propsNavigate, // Accept navigate as prop (for backwards compat)
  meeting_id,
  setShowSummary,
  isDetailsView,
  setMeetingAPIDetails,
  meetingAPIDetails,
}) => {
  // Use prop navigate if provided, otherwise use hook
  const hookNavigate = useNavigate();
  const navigate = propsNavigate || hookNavigate;
  const dispatch = useDispatch();
  const isPhoneOnly = isMobile && !isTablet;

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      if (!meetingTitle || !meetingTitle.trim().length > 0) {
        dispatch(openSnackbar('error', 'Meeting Title is Required.'));
      } else {
        onTitleSave();
      }
    }
  };
  const handleBlur = e => {
    if (!meetingTitle || !meetingTitle.trim().length > 0) {
      dispatch(openSnackbar('error', 'Meeting Title is Required.'));
    } else {
      onTitleBlur();
    }
  };

  return (
    <>
      {(Object.keys(details).length > 0 && details.isResume) ||
      !(Object.keys(details).length > 0) ? (
        <Box
          sx={{
            width: 'maxContext',
            maxWidth: '300px',
            display: 'flex',
            alignItems: 'flex-start',
            // gap: 1,
          }}
        >
            {isMobile && (
              <IconButton
                color="default"
                size="small"
                onClick={() => {
                  navigate(ROUTES.HISTORY);
                  setShowSummary(false);
                }}
                sx={{
                  marginLeft: '-4px',
                  marginRight: '4px',
                  flexShrink: 0,
                }}
              >
                <ArrowBackIcon fontSize="inherit" />
              </IconButton>
            )}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="caption"
              color="grey.400"
              component="div"
              fontWeight={400}
              lineHeight={'normal'}
              sx={{ mb: 0 }}
            >
              Meeting Title{' '}
              {isEditingTitle ? (
                <span style={{ color: '#ff5547' }}> *</span>
              ) : null}
            </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              {isEditingTitle ? (
                <TextField
                  value={meetingTitle}
                  onChange={e => {
                    dispatch(
                      setCurrentRecording({ meetingTitle: e.target.value })
                    );
                  }}
                  onKeyPress={handleKeyPress}
                  onBlur={handleBlur}
                  variant="standard"
                  autoFocus
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '1rem',
                      minWidth: '100px',
                      maxWidth: '150px',
                    },
                    '& .MuiInput-underline:before': {
                      borderBottom: 'none',
                    },
                    '& .MuiInput-underline:after': {
                      borderBottom: 'none',
                    },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                      borderBottom: 'none',
                    },
                  }}
                />
              ) : (
                <Typography
                  variant="body1"
                  color="text.primary"
                  noWrap
                  sx={{ fontWeight: 600, fontSize: '16px' }}
                >
                  {meetingTitle}
                </Typography>
              )}
              {meeting_id && (
                <IconButton
                  color="default"
                  size="small"
                  onClick={onTitleEdit}
                  disableFocusRipple
                  sx={{ '&.Mui-focusVisible': { outline: 'none' } }}
                >
                  <Edit fontSize="inherit" />
                </IconButton>
              )}
            </Stack>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            width: { xs: 'max-content', md: 'max-content' },
            display: 'flex',
            alignItems: 'flex-start',
            textAlign: 'left',
            borderRadius: 1,
            justifyContent: 'flex-start',
            gap: '4px',
          }}
        >
          <IconButton
            color="default"
            size="small"
            onClick={() => {
              navigate(ROUTES.HISTORY);
              setShowSummary(false);
            }}
            sx={{
              marginLeft: '-4px',
              marginRight: '4px',
              flexShrink: 0,
            }}
          >
            <ArrowBackIcon fontSize="inherit" />
          </IconButton>
          <Box
            sx={{
              width: '300px',
              flex: 1,
              minWidth: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '3px',
            }}
          >
            <Typography
              variant="caption"
              color="grey.400"
              fontWeight={400}
              component="div"
              lineHeight={'normal'}
              sx={{ mb: 0 }}
            >
              Meeting Title{' '}
              {!isEditingTitle ? (
                <span style={{ color: '#ff5547' }}> *</span>
              ) : null}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifyContent: 'flex-start' ,width: '300px'}}>
              {isEditingTitle ? (
                <TextField
                  value={meetingTitle}
                  onChange={e => {
                    // Update meetingAPIDetails if in details view, otherwise update Redux
                    if (isDetailsView && setMeetingAPIDetails) {
                      setMeetingAPIDetails({
                        ...meetingAPIDetails,
                        meetingTitle: e.target.value,
                      });
                    } else {
                      dispatch(
                        setCurrentRecording({ meetingTitle: e.target.value })
                      );
                    }
                  }}
                  onKeyPress={handleKeyPress}
                  onBlur={handleBlur}
                  variant="standard"
                  autoFocus
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '0.875rem',
                      minWidth: '100px',
                      maxWidth: '250px',
                    },
                    '& .MuiInput-underline:before': {
                      borderBottom: 'none',
                    },
                    '& .MuiInput-underline:after': {
                      borderBottom: 'none',
                    },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                      borderBottom: 'none',
                    },
                  }}
                />
              ) : (
                <Tooltip title={meetingTitle}>
                  <Typography
                    variant="body2"
                    component="div"
                    noWrap
                    fontWeight={500}
                    color="secondary.main"
                    sx={{
                    
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {meetingTitle}
                  </Typography>
                </Tooltip>
              )}
              {meeting_id && (
                <IconButton
                  color="default"
                  size="small"
                  onClick={onTitleEdit}
                  disableFocusRipple
                  sx={{ ml: 0.5, '&.Mui-focusVisible': { outline: 'none' } }}
                >
                  <Edit fontSize="inherit" />
                </IconButton>
              )}
            </Box>
          </Box>
          {!isPhoneOnly && (
            <>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ mx: 2, alignSelf: 'stretch' }}
          />
          <Box sx={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' ,gap:'6px'}}>
            <Typography
              variant="caption"
              color="grey.400"
              lineHeight={'normal'}
              sx={{ mb: 0 }}
            >
              Start Time
            </Typography>
            <Typography variant="body2" fontWeight={500} color="text.primary">
              {details.meetingDetails.startTime}
            </Typography>
          </Box>
            </>
          )}
        </Box>
      )}
    </>
  );
};

export default MeetingTitle;
